import { ReactElement } from 'react';
import React from 'react';

import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';
import { ResponsiveValue, SpacingProps } from '@shopify/restyle';

import { DEFAULT_FOOTER_MARGIN_TOP, FooterRG } from './FooterRG';
import { PredictionsFooter } from './PredictionsFooter';
import { Box } from './lib/components';
import { AppSpacing, AppTheme } from './lib/theme';

/**
 * FooterRG component that can be placed inside Scroll containers to fill their height and be always at the bottom.
 * Make sure to specify flexGrow:1 on parent container so this can fill the height.
 */
export const BottomFooterRG = ({
    footerMarginTop,
    ...props
}: {
    footerMarginTop?: ResponsiveValue<AppSpacing, {}>;
} & SpacingProps<AppTheme>): ReactElement => {
    const isPredictions = useIsPredictionsProduct();

    return (
        <Box flex={1} justifyContent="flex-end" {...props}>
            <Box marginTop={footerMarginTop ?? DEFAULT_FOOTER_MARGIN_TOP}>
                {isPredictions ? <PredictionsFooter marginTop="s0" /> : <FooterRG marginTop="s0" />}
            </Box>
        </Box>
    );
};
